export const MasterPermission = {
  1: [
    {
      name: "Dashboard",
      children: [
        {
          id: "dashboard",
          name: "Dashboard",
          isread: true,
        },
      ],
    },

    {
      name: "Profile",
      isread: true,
      id: "profile",
      children: [
        {
          id: "profile",
          name: "User Profile",
          isread: true,
          isupdate: true,
        },
        {
          id: "members",
          name: "Members",
          isread: true,
          isupdate: true,
          iscreate: true,
        },
        {
          id: "followers",
          name: "Followers",
          isread: true,
        },
      ],
    },
    {
      name: "Posts",
      isread: true,
      id: "posts",
      children: [
        {
          id: "my_post",
          name: "My Posts",
          isread: true,
          isupdate: true,
          iscreate: true,
          isdelete: true,
        },

        {
          id: "notifications",
          name: "Notifications",
          isread: true,
        },
      ],
    },

    {
      name: "Play",
      id: "play",
      isread: true,
      children: [
        {
          id: "tournaments",
          name: "Tournaments/Events",
          isread: true,
          isupdate: true,
          iscreate: true,
          isdelete: true,
        },
        {
          id: "tour",
          name: "Tour",
          isread: true,
          isupdate: true,
          iscreate: true,
          isdelete: true,
        },

        {
          id: "golfhubber_pairs",
          name: "Golfhubber Pair",
          isread: true,
          isupdate: true,
          iscreate: true,
          isdelete: true,
        },
        {
          id: "leagues",
          name: "Leagues",
          isread: true,
          isupdate: true,
          iscreate: true,
          isdelete: true,
        },
      ],
    },
    {
      name: "Pro Shop",
      id: "pro_shop",
      isread: true,
      children: [
        {
          id: "voucher",
          name: "Voucher/Product",
          isread: true,
          isupdate: true,
          iscreate: true,
          isdelete: true,
        },
        {
          id: "orders",
          name: "Orders",
          isread: true,
          isupdate: true,
        },

        {
          id: "manage_stripe",
          name: "Manage Stripe",
          isread: true,
          isupdate: true,
        },
        {
          id: "transactions",
          name: "Transactions",
          isread: true,
        },
        {
          id: "subscriptions",
          name: "Subscriptions",
          isread: true,
          iscreate: true,
        },
      ],
    },
    {
      name: "General",
      id: "general",
      isread: true,
      children: [
        {
          id: "reports",
          name: "Reports",
          isread: true,
          isupdate: true,
        },

        {
          id: "change_password",
          name: "Change Password",
          isread: true,
          isupdate: true,
        },
      ],
    },
  ],
  3: [
    {
      name: "Dashboard",
      children: [
        {
          id: "dashboard",
          name: "Dashboard",
          isread: true,
        },
      ],
    },
    {
      name: "Community",
      isread: true,
      id: "community",
      children: [
        {
          id: "app_users",
          name: "App Users",
          isread: true,
          isupdate: true,
          isdelete: true,
        },
        {
          id: "amateur",
          name: "Amateur",
          isread: true,
          isupdate: true,
          isdelete: true,
        },
        {
          id: "pros",
          name: "Pros",
          isread: true,
          isupdate: true,
          isdelete: true,
        },
        {
          id: "clubs",
          name: "Clubs",
          isread: true,
          isupdate: true,
          isdelete: true,
          iscreate: true,
        },
        {
          id: "company",
          name: "Company",
          isread: true,
          isupdate: true,
          isdelete: true,
          iscreate: true,
        },
        {
          id: "tours",
          name: "Tours",
          isread: true,
          isupdate: true,
          isdelete: true,
          iscreate: true,
        },
        {
          id: "societies",
          name: "Societies",
          isread: true,
          isupdate: true,
          isdelete: true,
          iscreate: true,
        },
        {
          id: "insight_manager",
          name: "Insight Manager",
          isread: true,
          isupdate: true,
          isdelete: true,
          iscreate: true,
        },
      ]
    },
    {
      name: "Portfolio",
      isread: true,
      id: "portfolio",
      children: [
        {
          id: "gh_mobile_app",
          name: "GH Mobile App",
          isread: true,
          isupdate: true,
        },
        {
          id: "marketing_pop_up",
          name: "Marketing Pop up",
          isread: true,
          isupdate: true,
        },
        {
          id: "in_app_advertising",
          name: "In App Advertising",
          isread: true,
          isupdate: true,
          iscreate: true,
          isdelete: true,

        },
        {
          id: "birdietime",
          name: "Birdietime",
          isread: true,
        },
        {
          id: "gh_pro",
          name: "GH Pro",
          isread: true,
        },

        {
          id: "club_package",
          name: "Club Package",
          isread: true,
        },
        {
          id: "zest",
          name: "Zest Partnership",
          isread: true,
        },
      ]
    },
    {
      name: "Profile",
      isread: true,
      id: "profile",
      children: [
        {
          id: "profile",
          name: "My Profile",
          isread: true,
          isupdate: true,
        },
        // {
        //   id: "members",
        //   name: "Members",
        //   isread: true,
        //   isupdate: true,
        //   iscreate: true,
        // },


      ],
    },
    {
      name: "Posts",
      isread: true,
      id: "posts",
      children: [
        {
          id: "all_post",
          name: "All Posts",
          isread: true,
          isupdate: true,
          iscreate: true,
          isdelete: true,
        },
        {
          id: "my_post",
          name: "My Posts",
          isread: true,
          isupdate: true,
          iscreate: true,
          isdelete: true,
        },

        {
          id: "notifications",
          name: "My Notifications",
          isread: true,
        },
           {
          id: "followers",
          name: "My Followers",
          isread: true,
        },
        {
          id: "followers_request",
          name: "Follower request",
          isread: true,
          isupdate: true,
          iscreate: true,
          isdelete: true,
        },
        {
          id: "insight_manager",
          name: "Insight Manager",
          isread: true,
          isupdate: true,
          iscreate: true,
          isdelete: true,
        },
        // {
        //   id: "magazine_portal",
        //   name: "Magazine Portal",
        //   isread: true,
        //   isupdate: true,
        //   iscreate: true,
        //   isdelete: true,
        // },
      ],
    },

    {
      name: "Play",
      id: "play",
      isread: true,
      children: [
        {
          id: "tournaments",
          name: "Tournaments/Events",
          isread: true,
          isupdate: true,
          iscreate: true,
          isdelete: true,
        },
        {
          id: "multi_round",
          name: "Multi Round",
          isread: true,
          isupdate: true,
          iscreate: true,
          isdelete: true,
        },
        {
          id: "leagues",
          name: "Leagues/OOM",
          isread: true,
          isupdate: true,
          iscreate: true,
          isdelete: true,
        },
        {
          id: "tour",
          name: "Tour",
          isread: true,
          isupdate: true,
          iscreate: true,
          isdelete: true,
        },

        // {
        //   id: "golfhubber_pairs",
        //   name: "Golfhubber Pair",
        //   isread: true,
        //   isupdate: true,
        //   iscreate: true,
        //   isdelete: true,
        // },

      ],
    },
    {
      name: "Pro Shop",
      id: "pro_shop",
      isread: true,
      children: [
        {
          id: "voucher",
          name: "Voucher/Product",
          isread: true,
          isupdate: true,
          iscreate: true,
          isdelete: true,
        },
        {
          id: "orders",
          name: "My orders received",
          isread: true,
          isupdate: true,
        },

        {
          id: "manage_stripe",
          name: "Manage My Payments",
          isread: true,
          isupdate: true,
        },
        // {
        //   id: "transactions",
        //   name: "Transactions",
        //   isread: true,
        // },
        // {
        //   id: "subscriptions",
        //   name: "Subscriptions",
        //   isread: true,
        //   iscreate: true,
        // },
      ],
    },
    {
      name: "Practice",
      id: "practice",
      isread: true,
    },
    {
      name: "General",
      id: "general",
      isread: true,
      children: [
        {
          id: "reports",
          name: "Reports",
          isread: true,
          isupdate: true,
        },

        {
          id: "change_password",
          name: "Change Password",
          isread: true,
          isupdate: true,
        },
      ],
    },
  ],
  4: [
    {
      name: "Dashboard",
      children: [
        {
          id: "dashboard",
          name: "Dashboard",
          isread: true,
        },
      ],
    },
    {
      name: "Profile",
      isread: true,
      id: "profile",
      children: [
        {
          id: "profile",
          name: "User Profile",
          isread: true,
          isupdate: true,
        },
        // {
        //   id: "role_manager",
        //   name: "Role Manager",
        //   isread: true,
        //   isupdate: true
        // },
        {
          id: "members",
          name: "Members",
          isread: true,
          isupdate: true,
          iscreate: true,
        },
        // {
        //   id: "insight_manager",
        //   name: "Insight Manager",
        //   isread: true,
        //   isupdate: true,
        //   iscreate: true,
        //   isdelete: true
        // },
        {
          id: "followers",
          name: "Followers",
          isread: true,
        },
      ],
    },
    {
      name: "Posts",
      isread: true,
      id: "posts",
      children: [
        {
          id: "my_post",
          name: "My Posts",
          isread: true,
          isupdate: true,
          iscreate: true,
          isdelete: true,
        },

        {
          id: "notifications",
          name: "Notifications",
          isread: true,
        },
      ],
    },

    {
      name: "Play",
      id: "play",
      isread: true,
      children: [
        {
          id: "tournaments",
          name: "Tournaments/Events",
          isread: true,
          isupdate: true,
          iscreate: true,
          isdelete: true,
        },
        {
          id: "tour",
          name: "Tour",
          isread: true,
          isupdate: true,
          iscreate: true,
          isdelete: true,
        },

        {
          id: "golfhubber_pairs",
          name: "Golfhubber Pair",
          isread: true,
          isupdate: true,
          iscreate: true,
          isdelete: true,
        },
        {
          id: "leagues",
          name: "Leagues",
          isread: true,
          isupdate: true,
          iscreate: true,
          isdelete: true,
        },
      ],
    },
    {
      name: "Pro Shop",
      id: "pro_shop",
      isread: true,
      children: [
        {
          id: "voucher",
          name: "Voucher/Product",
          isread: true,
          isupdate: true,
          iscreate: true,
          isdelete: true,
        },
        {
          id: "orders",
          name: "Orders",
          isread: true,
          isupdate: true,
        },

        {
          id: "manage_stripe",
          name: "Manage Stripe",
          isread: true,
          isupdate: true,
        },
        {
          id: "transactions",
          name: "Transactions",
          isread: true,
        },
        {
          id: "subscriptions",
          name: "Subscriptions",
          isread: true,
          iscreate: true,
        },
      ],
    },
    {
      name: "General",
      id: "general",
      isread: true,
      children: [
        {
          id: "reports",
          name: "Reports",
          isread: true,
          isupdate: true,
        },

        {
          id: "change_password",
          name: "Change Password",
          isread: true,
          isupdate: true,
        },
      ],
    },
  ],
  5: [
    {
      name: "Dashboard",
      children: [
        {
          id: "dashboard",
          name: "Dashboard",
          isread: true,
        },
      ],
    },
    {
      name: "Profile",
      id: "profile",
      isread: true,
      children: [
        {
          id: "profile",
          name: "User Profile",
          isread: true,
          isupdate: true,
        },
        // {
        //   id: "role_manager",
        //   name: "Role Manager",
        //   isread: true,
        //   isupdate: true
        // },
        {
          id: "members",
          name: "Members",
          isread: true,
          isupdate: true,
          iscreate: true,
        },
        {
          id: "insight_manager",
          name: "Insight Manager",
          isread: true,
          isupdate: true,
          iscreate: true,
          isdelete: true,
        },
        {
          id: "followers",
          name: "Followers",
          isread: true,
        },
      ],
    },
    {
      name: "Posts",
      isread: true,
      id: "posts",
      children: [
        {
          id: "my_post",
          name: "My Posts",
          isread: true,
          isupdate: true,
          iscreate: true,
          isdelete: true,
        },

        {
          id: "notifications",
          name: "Notifications",
          isread: true,
        },
      ],
    },
    {
      name: "Pro Shop",
      id: "pro_shop",
      isread: true,
      children: [
        {
          id: "voucher",
          name: "Voucher/Product",
          isread: true,
          isupdate: true,
          iscreate: true,
          isdelete: true,
        },
        {
          id: "orders",
          name: "Orders",
          isread: true,
          isupdate: true,
        },

        {
          id: "manage_stripe",
          name: "Manage Stripe",
          isread: true,
          isupdate: true,
        },
        {
          id: "transactions",
          name: "Transactions",
          isread: true,
        },
        {
          id: "subscriptions",
          name: "Subscriptions",
          isread: true,
          iscreate: true,
        },
      ],
    },
    {
      name: "General",
      id: "general",
      isread: true,
      children: [
        {
          id: "reports",
          name: "Reports",
          isread: true,
          isupdate: true,
        },

        {
          id: "change_password",
          name: "Change Password",
          isread: true,
          isupdate: true,
        },
      ],
    },
  ],
  6: [
    {
      name: "Dashboard",
      children: [
        {
          id: "dashboard",
          name: "Dashboard",
          isread: true,
        },
      ],
    },
    {
      name: "Profile",
      isread: true,
      id: "profile",
      children: [
        {
          id: "profile",
          name: "User Profile",
          isread: true,
          isupdate: true,
        },
        // {
        //   id: "role_manager",
        //   name: "Role Manager",
        //   isread: true,
        //   isupdate: true
        // },
        {
          id: "members",
          name: "Members",
          isread: true,
          isupdate: true,
          iscreate: true,
        },
        // {
        //   id: "insight_manager",
        //   name: "Insight Manager",
        //   isread: true,
        //   isupdate: true,
        //   iscreate: true,
        //   isdelete: true
        // },
        {
          id: "followers",
          name: "Followers",
          isread: true,
        },
        {
          id: "followers_request",
          name: "Follower Request",
          isread: true,
          isupdate: true,
        },
      ],
    },
    {
      name: "Posts",
      isread: true,
      id: "posts",
      children: [
        {
          id: "my_post",
          name: "My Posts",
          isread: true,
          isupdate: true,
          iscreate: true,
          isdelete: true,
        },

        {
          id: "notifications",
          name: "Notifications",
          isread: true,
        },
      ],
    },

    {
      name: "Play",
      id: "play",
      isread: true,
      children: [
        {
          id: "tournaments",
          name: "Tournaments/Events",
          isread: true,
          isupdate: true,
          iscreate: true,
          isdelete: true,
        },
        {
          id: "tour",
          name: "Tour",
          isread: true,
          isupdate: true,
          iscreate: true,
          isdelete: true,
        },

        {
          id: "golfhubber_pairs",
          name: "Golfhubber Pair",
          isread: true,
          isupdate: true,
          iscreate: true,
          isdelete: true,
        },
        {
          id: "leagues",
          name: "Leagues",
          isread: true,
          isupdate: true,
          iscreate: true,
          isdelete: true,
        },
      ],
    },

    {
      name: "General",
      id: "general",
      isread: true,
      children: [
        {
          id: "reports",
          name: "Reports",
          isread: true,
          isupdate: true,
        },

        {
          id: "change_password",
          name: "Change Password",
          isread: true,
          isupdate: true,
        },
      ],
    },
  ],
  7: [
    {
      name: "Dashboard",
      children: [
        {
          id: "dashboard",
          name: "Dashboard",
          isread: true,
        },
      ],
    },
    {
      name: "Profile",
      isread: true,
      id: "profile",
      children: [
        {
          id: "profile",
          name: "User Profile",
          isread: true,
          isupdate: true,
        },
        {
          id: "members",
          name: "Members",
          isread: true,
          isupdate: true,
          iscreate: true,
        },
        // {
        //   id: "role_manager",
        //   name: "Role Manager",
        //   isread: true,
        //   isupdate: true
        // },
        // {
        //   id: "insight_manager",
        //   name: "Insight Manager",
        //   isread: true,
        //   isupdate: true,
        //   iscreate: true,
        //   isdelete: true
        // },
        {
          id: "followers",
          name: "Followers",
          isread: true,
        },
        {
          id: "followers_request",
          name: "Follower Request",
          isread: true,
          isupdate: true,
        },
      ],
    },
    {
      name: "Posts",
      isread: true,
      id: "posts",
      children: [
        {
          id: "my_post",
          name: "My Posts",
          isread: true,
          isupdate: true,
          iscreate: true,
          isdelete: true,
        },

        {
          id: "notifications",
          name: "Notifications",
          isread: true,
        }
      ],
    },

    {
      name: "Play",
      id: "play",
      isread: true,
      children: [
        {
          id: "tournaments",
          name: "Tournaments/Events",
          isread: true,
          isupdate: true,
          iscreate: true,
          isdelete: true,
        },
        {
          id: "tour",
          name: "Tour",
          isread: true,
          isupdate: true,
          iscreate: true,
          isdelete: true,
        },

        {
          id: "golfhubber_pairs",
          name: "Golfhubber Pair",
          isread: true,
          isupdate: true,
          iscreate: true,
          isdelete: true,
        },
        {
          id: "leagues",
          name: "Leagues",
          isread: true,
          isupdate: true,
          iscreate: true,
          isdelete: true,
        },
      ],
    },
    {
      name: "Pro Shop",
      id: "pro_shop",
      isread: true,
      children: [
        {
          id: "voucher",
          name: "Voucher/Product",
          isread: true,
          isupdate: true,
          iscreate: true,
          isdelete: true,
        },
        {
          id: "orders",
          name: "Orders",
          isread: true,
          isupdate: true,
        },

        {
          id: "manage_stripe",
          name: "Manage Stripe",
          isread: true,
          isupdate: true,
        },
        {
          id: "transactions",
          name: "Transactions",
          isread: true,
        },
        {
          id: "subscriptions",
          name: "Subscriptions",
          isread: true,
          iscreate: true,
        },
      ],
    },
    {
      name: "General",
      id: "general",
      isread: true,
      children: [
        {
          id: "reports",
          name: "Reports",
          isread: true,
          isupdate: true,
        },

        {
          id: "change_password",
          name: "Change Password",
          isread: true,
          isupdate: true,
        },
      ],
    },
  ],
};
